// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","linkText":"Footer_linkText__tr32P","facebookLink":"Footer_facebookLink__S2VtC","copyrightContainer":"Footer_copyrightContainer__GtuEi"};